import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import {
  AppsRounded,
  ArrowBackIosRounded,
  ArrowBackRounded,
} from '@mui/icons-material';
import { StyledRecordingHeader } from './index.style';

const RecordingHeader = ({
  isRecording,
  isRehearing,
  loadingUpdateAudio,
  currentIndex,
  sentences,
  handlePreviousSentence,
  handleOpenGridSentenceDialog,
}) => {
  const arrowBackBtndisabled = isRecording || isRehearing || loadingUpdateAudio;
  const gridBtndisabled = isRecording || isRehearing || loadingUpdateAudio;
  const ArrowIcon = currentIndex === 0 ? ArrowBackRounded : ArrowBackIosRounded;

  return (
    <StyledRecordingHeader>
      <Button
        className="back-btn"
        onClick={handlePreviousSentence}
        disabled={arrowBackBtndisabled}
      >
        <ArrowIcon
          className={`icon ${arrowBackBtndisabled ? 'disabled' : ''}`}
        />
      </Button>
      <Box className="sentence">
        <Typography className="current-sentence">{currentIndex + 1}</Typography>
        <Typography className="total-sentences">/{sentences.length}</Typography>
      </Box>
      <Button
        className="grid-button"
        onClick={handleOpenGridSentenceDialog}
        disabled={gridBtndisabled}
      >
        <AppsRounded
          className={`grid-button-icon ${gridBtndisabled ? 'disabled' : ''}`}
        />
      </Button>
    </StyledRecordingHeader>
  );
};

export default RecordingHeader;
